import Vue from 'vue';
import LeadFormHolder from './LeadFormHolder';

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ru-RU'
import '../../plugins/element.js'

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

export default function (settings) {
  new Vue({
    data: {
      settings,
    },
    render: h => h(LeadFormHolder, {
      props: {
        settings,
      },
    }),
  }).$mount(settings.lead?.el || '#mag');
}
